import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';

/**
 * Public API - No authentication required
 * Used for public endpoints that don't need a bearer token
 */
export const publicApi = createApi({
  reducerPath: 'publicApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    // No prepareHeaders - public endpoints don't need auth token
  }),
  endpoints: (build) => ({
    /**
     * Confirm admin invitation
     * POST /public/admin-invite/confirm
     */
    confirmAdminInvite: build.mutation<
      {
        message: string;
        success: boolean;
      },
      { token: string }
    >({
      transformResponse: (response: { data: any }) => response.data,
      query: (data) => ({
        url: '/public/admin-invite/confirm',
        method: 'POST',
        body: data,
      }),
    }),
    /**
     * Confirm stock owner invitation
     * POST /public/stockowner-invite/confirm
     */
    confirmStockOwnerInvite: build.mutation<
      {
        message: string;
        success: boolean;
      },
      { token: string }
    >({
      transformResponse: (response: { data: any }) => response.data,
      query: (data) => ({
        url: '/public/stockowner-invite/confirm',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { 
  useConfirmAdminInviteMutation,
  useConfirmStockOwnerInviteMutation,
} = publicApi;

